const {createRequestGate} = require('./requests.cjs')
const {deParameters, resolveEdition} = require('./editions.cjs')
const ENTITIES = ['subjects', 'grades', 'standards', 'expectations']
function parameters(entity, filters, language) {
  return deParameters(entity, {...filters, standard_set:resolveEdition(filters.standard_set)}, language)
}
function key(entity, filters, language) {
  return JSON.stringify(parameters(entity, filters, language))
}
function createStandardsDataController(load, notify = () => {}) {
  const gate = createRequestGate()
  const states = {}
  const keys = {}
  let disposed = false
  const emit = (entity, state) => {
    states[entity] = state
    if (!disposed) notify(entity, state, {...states})
  }
  function request(entity, filters, language, force = false) {
    if (disposed) return Promise.resolve()
    const nextKey = key(entity, filters, language)
    if (!force && keys[entity] === nextKey) return Promise.resolve(states[entity])
    keys[entity] = nextKey
    const current = gate.begin(entity)
    emit(entity, {items:[], status:'loading', error:null})
    return Promise.resolve().then(() => load(entity, parameters(entity, filters, language)))
      .then(items => {
        if (!current() || disposed) return
        if (!Array.isArray(items)) throw new TypeError('Expected an array')
        emit(entity, {items, status:items.length ? 'ready' : 'empty', error:null})
      }).catch(error => {
        if (current() && !disposed) emit(entity, {items:[], status:'error', error})
      })
  }
  return {
    refresh(filters, language) {return Promise.all(ENTITIES.map(entity => request(entity, filters, language)))},
    retry(entity, filters, language) {return request(entity, filters, language, true)},
    snapshot() {return {...states}},
    dispose() {disposed = true; ENTITIES.forEach(entity => gate.invalidate(entity))}
  }
}
module.exports = {ENTITIES, parameters, key, createStandardsDataController}
